export default __webpack_public_path__ + "static/media/ladies-tour1.1c6712c7.jpg";